const PrivacyPolicy = () => {
  return (
    <div
      style={{
        background:
          'radial-gradient(104.43% 103.76% at 49.87% 36.88%, #FFFBE3 10.55%, #FFFBE3 21.07%, #E1FFE3 54.33%)',
        minHeight: '100vh',
        padding: '20px',
        position: 'absolute',
        width: '100%',
        overflowY: 'auto',
      }}
    >
      <div
        style={{
          maxWidth: '1000px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
          overflow: 'visible',
        }}
      >
        {/* Header */}
        <header
          style={{
            background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
            color: 'white',
            padding: '40px 30px',
            textAlign: 'center',
            borderRadius: '20px 20px 0 0',
          }}
        >
          <h1
            style={{ fontSize: '2.5em', marginBottom: '10px', fontWeight: 700 }}
          >
            CHARTE
          </h1>
          <div style={{ fontSize: '1.2em', opacity: 0.95 }}>
            POLITIQUE DE CONFIDENTIALITÉ
            <br />
            ET DE PROTECTION DES DONNÉES PERSONNELLES
          </div>
          <div
            style={{
              marginTop: '15px',
              padding: '8px 20px',
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '20px',
              display: 'inline-block',
              fontSize: '0.9em',
            }}
          >
            Mise à jour du 1er avril 2026
          </div>
        </header>

        {/* Content */}
        <div style={{ padding: '40px 30px' }}>
          {/* Introduction */}
          <section id="introduction">
            <div
              style={{
                background:
                  'linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(46, 125, 50, 0.1) 100%)',
                padding: '20px',
                borderRadius: '10px',
                marginBottom: '40px',
                border: '1px solid rgba(76, 175, 80, 0.3)',
              }}
            >
              <p style={{ marginBottom: '15px' }}>
                Vous visitez notre Site Web ou l'application Pikkopay (désignés
                ensemble ci-après le « Site ») : nous sommes très concernés par
                la protection de votre vie privée et souhaitons établir avec
                vous des relations de confiance.
              </p>
              <p>
                <strong>
                  Notre Site s'adresse à des personnes âgées de 18 ans et plus.
                </strong>{' '}
                Nous ne collectons pas délibérément d'informations relatives à
                des mineurs, lesquels ne sont pas autorisés à s'y inscrire.
              </p>
            </div>
          </section>

          {/* Section 1 - Responsable */}
          <section id="responsable" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              QUI EST LE RESPONSABLE DU TRAITEMENT DE VOS DONNÉES PERSONNELLES ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Notre société est responsable du traitement de vos données
              personnelles collectées sur notre Site et nous mettons tout en
              œuvre pour les protéger.
            </p>
            <p style={{ marginBottom: '15px' }}>
              Pour tous commentaires, questions ou demandes relatives à la
              présente Charte, veuillez nous contacter aux coordonnées suivantes
              :
            </p>
            <div
              style={{
                background: '#f8f9fa',
                padding: '25px',
                borderRadius: '12px',
                margin: '20px 0',
                borderLeft: '4px solid #4CAF50',
              }}
            >
              <p style={{ marginBottom: '8px' }}>
                <strong style={{ color: '#4CAF50' }}>Société :</strong> PIKKOPAY
              </p>
              <p style={{ marginBottom: '8px' }}>
                <strong style={{ color: '#4CAF50' }}>Siège social :</strong> 2
                rue Gustave Eiffel, 10430 Rosières-près-Troyes
              </p>
              <p style={{ marginBottom: '8px' }}>
                <strong style={{ color: '#4CAF50' }}>Email :</strong>{' '}
                contact@pikkopay.fr
              </p>
              <p style={{ marginBottom: '8px' }}>
                <strong style={{ color: '#4CAF50' }}>
                  Directeur de publication :
                </strong>{' '}
                Joe Trinh
              </p>
              <p>
                <strong>DPO :</strong>{' '}
                <a href="mailto:contact@dipeeo.com">contact@dipeeo.com</a>
              </p>
            </div>
          </section>

          {/* Section 2 - Données collectées */}
          <section id="donnees" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              QUELLES DONNÉES PERSONNELLES COLLECTONS-NOUS ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Les données que nous collectons sont traitées de manière
              confidentielle. Elles ne sont divulguées à des tiers qu'en stricte
              conformité avec les dispositions de la présente Charte et dans les
              cas expressément décrits à la section 4 ci-après. Nous les
              collectons des manières décrites ci-après.
            </p>

            <h3
              style={{
                color: '#2E7D32',
                fontSize: '1.3em',
                marginTop: '20px',
                marginBottom: '15px',
              }}
            >
              2.1 LES DONNÉES QUE VOUS NOUS FOURNISSEZ
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nous collectons les données personnelles que vous déclarez
              volontairement depuis un formulaire de collecte lors de vos
              visites sur notre Site.
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                des données de contact, telles que vos civilité, nom, adresse
                e-mail, adresse postale, numéro de téléphone fixe et/ou mobile,
                code interne de traitement permettant l'identification et vos
                réseaux sociaux ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                vos références de connexion au(x) Service(s), telles que nom
                d'utilisateur et mot de passe ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                vos modes de paiement (numéro d'une carte de crédit par
                exemple).
              </li>
            </ul>

            <h3
              style={{
                color: '#2E7D32',
                fontSize: '1.3em',
                marginTop: '20px',
                marginBottom: '15px',
              }}
            >
              2.2 LES DONNÉES RECUEILLIES AUPRÈS D'AUTRES SOURCES
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nous pouvons également obtenir vos coordonnées et autres
              informations personnelles auprès d'autres parties tierces.
            </p>

            <h3
              style={{
                color: '#2E7D32',
                fontSize: '1.3em',
                marginTop: '20px',
                marginBottom: '15px',
              }}
            >
              2.3 LES DONNÉES DE L'UTILISATION DU SERVICE, Y COMPRIS LES COOKIES
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Lors de votre navigation sur notre Site des cookies et autres
              traceurs sont déposés sur votre navigateur.
            </p>
            <div
              style={{
                background: '#fff3cd',
                borderLeft: '4px solid #ffc107',
                padding: '15px',
                margin: '15px 0',
                borderRadius: '5px',
              }}
            >
              <p style={{ marginBottom: '10px' }}>
                <strong>Important :</strong> Les Cookies techniques et
                fonctionnels sont nécessaires au bon fonctionnement du Site et
                ne requièrent pas de consentement de votre part.
              </p>
              <p>
                Les Cookies publicitaires, de réseaux sociaux, de
                personnalisation de contenu et d'analyse d'audience sont soumis
                à votre consentement express.
              </p>
            </div>

            {/* 2.4 LOCALISATION */}
            <h3
              style={{
                color: '#2E7D32',
                fontSize: '1.3em',
                marginTop: '30px',
                marginBottom: '15px',
              }}
            >
              2.4 DONNÉES DE LOCALISATION GÉOGRAPHIQUE
            </h3>
            <div
              style={{
                background: '#fff3cd',
                borderLeft: '4px solid #ffc107',
                padding: '15px',
                margin: '15px 0',
                borderRadius: '5px',
              }}
            >
              <p>
                <strong>Information importante :</strong> L'application Pikkopay
                accède à votre localisation géographique, y compris en
                arrière-plan durant la session d'achat. Conformément à l'article
                13 du Règlement (UE) 2016/679 (RGPD) et à la loi n° 78-17 du 6
                janvier 1978 modifiée, nous vous en informons de manière
                transparente ci-après.
              </p>
            </div>
            <p style={{ marginBottom: '15px' }}>
              Dans le cadre de l'utilisation de l'application Pikkopay, votre{' '}
              <strong>localisation géographique précise</strong> (via le GPS de
              votre appareil) ou <strong>approximative</strong> (via les réseaux
              Wi-Fi ou cellulaires) est collectée, ci-après la « Donnée de
              Localisation ».
            </p>

            <h4
              style={{
                color: '#2E7D32',
                fontSize: '1.1em',
                marginTop: '15px',
                marginBottom: '10px',
              }}
            >
              Nature et modalités de la collecte
            </h4>
            <p style={{ marginBottom: '10px' }}>
              La Donnée de Localisation est collectée selon deux modalités
              distinctes :
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>En premier plan (foreground)</strong> : lors de
                l'utilisation active de l'application, pour identifier le point
                de vente partenaire le plus proche et initialiser la session
                d'achat ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>En arrière-plan (background)</strong> : lorsque
                l'application est ouverte mais non active à l'écran, afin de{' '}
                <strong>
                  vérifier en continu que l'utilisateur se trouve bien dans le
                  magasin partenaire sélectionné
                </strong>{' '}
                tout au long du parcours d'achat (entrée en magasin, session de
                scan, validation du paiement). Cette vérification constitue une
                mesure de sécurité essentielle destinée à prévenir tout paiement
                effectué par erreur dans un magasin différent de celui
                sélectionné.
              </li>
            </ul>

            <h4
              style={{
                color: '#2E7D32',
                fontSize: '1.1em',
                marginTop: '15px',
                marginBottom: '10px',
              }}
            >
              Finalités déterminées et légitimes
            </h4>
            <ul style={{ marginLeft: '30px', marginBottom: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                Identifier automatiquement le magasin partenaire Pikkopay le
                plus proche afin d'initialiser la session Scan &amp; Go
                appropriée ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Vérifier, tout au long du parcours d'achat, que l'utilisateur se
                trouve physiquement dans le magasin correspondant à la session
                de paiement en cours, afin de{' '}
                <strong>
                  garantir l'intégrité des transactions et prévenir tout
                  paiement frauduleux ou erroné
                </strong>{' '}
                ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Désactiver automatiquement la session d'achat en cas de
                détection d'une incohérence entre la position de l'utilisateur
                et le point de vente sélectionné.
              </li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              La Donnée de Localisation n'est utilisée à aucune autre fin,
              notamment pas à des fins publicitaires, de profilage
              comportemental, ou de cession à des tiers à titre commercial.
            </p>

            <h4
              style={{
                color: '#2E7D32',
                fontSize: '1.1em',
                marginTop: '15px',
                marginBottom: '10px',
              }}
            >
              Base légale
            </h4>
            <p style={{ marginBottom: '10px' }}>
              Le traitement de la Donnée de Localisation repose sur deux bases
              légales cumulatives :
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                L'<strong>exécution du contrat</strong> au sens de l'article 6,
                paragraphe 1, point b) du RGPD : la vérification de la présence
                en magasin est une condition technique indispensable à la
                fourniture du service Scan &amp; Go et à la sécurisation des
                paiements ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                L'<strong>intérêt légitime</strong> de PIKKOPAY au sens de
                l'article 6, paragraphe 1, point f) du RGPD : prévenir la
                fraude, sécuriser les transactions et protéger les intérêts
                financiers des enseignes partenaires et des utilisateurs contre
                tout paiement effectué dans le mauvais établissement.
              </li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              La collecte en arrière-plan est strictement limitée à la durée de
              la session d'achat active et cesse automatiquement à l'issue du
              paiement ou à la fermeture de l'application.
            </p>

            <h4
              style={{
                color: '#2E7D32',
                fontSize: '1.1em',
                marginTop: '15px',
                marginBottom: '10px',
              }}
            >
              Droit d'opposition et conséquences
            </h4>
            <p style={{ marginBottom: '15px' }}>
              Vous pouvez désactiver l'accès à la localisation dans les
              paramètres de votre appareil (Réglages &gt; Confidentialité &gt;
              Localisation sur iOS ; Paramètres &gt; Applications &gt; Pikkopay
              &gt; Autorisations sur Android).
            </p>
            <p style={{ marginBottom: '15px' }}>
              Toutefois, la désactivation de la localisation en arrière-plan{' '}
              <strong>désactive la vérification de présence en magasin</strong>{' '}
              et peut rendre le service Scan &amp; Go indisponible ou limiter
              certaines fonctionnalités de sécurité des paiements. La sélection
              manuelle du magasin reste possible mais ne garantit pas le même
              niveau de sécurité transactionnelle.
            </p>

            <h4
              style={{
                color: '#2E7D32',
                fontSize: '1.1em',
                marginTop: '15px',
                marginBottom: '10px',
              }}
            >
              Durée de conservation
            </h4>
            <p style={{ marginBottom: '15px' }}>
              La Donnée de Localisation est utilisée en temps réel pendant la
              durée de la session d'achat active. Elle n'est{' '}
              <strong>pas conservée de manière permanente</strong> sur nos
              serveurs au-delà du temps strictement nécessaire à la vérification
              de présence en magasin et à la sécurisation du paiement. Elle
              n'est associée à aucun historique de déplacements.
            </p>
          </section>

          {/* Section 3 - Utilisation */}
          <section id="utilisation" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              3. COMMENT UTILISONS-NOUS VOS DONNÉES PERSONNELLES ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Selon les relations que nous avons ensemble, nous utilisons vos
              données personnelles pour :
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>
                Fournir, activer et gérer votre accès au Site et votre
                utilisation de celui-ci ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Traiter et répondre à une demande, une commande ou à toute autre
                transaction ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Fournir un support technique, un service ou produit
                complémentaire ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Améliorer le Site et développer nos autres produits et services
                ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Offrir un contenu personnalisé ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Répondre à vos demandes, recherches, commentaires et
                préoccupations ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Notifier les modifications, mises à jour et autres annonces ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                Nous conformer à nos obligations légales ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>
                  Identifier le point de vente partenaire et vérifier la
                  présence physique de l'utilisateur en magasin
                </strong>
                , en premier plan et en arrière-plan pendant la durée de la
                session d'achat, afin de garantir l'intégrité des paiements Scan
                &amp; Go (articles 6.1.b et 6.1.f du RGPD).
              </li>
            </ul>
          </section>

          {/* Section 4 - Partage */}
          <section id="partage" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              4. AVEC QUI POUVONS-NOUS PARTAGER VOS DONNÉES ?
            </h2>

            {/* 4.1 corrigé : suppression du langage B2B incohérent, remplacé par la réalité du modèle Pikkopay */}
            <h3
              style={{
                color: '#2E7D32',
                fontSize: '1.3em',
                marginTop: '20px',
                marginBottom: '15px',
              }}
            >
              4.1 ENSEIGNES PARTENAIRES
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Dans le cadre de la fourniture du service Scan &amp; Go, certaines
              données transactionnelles (identifiant de session, panier,
              montant, statut du paiement) peuvent être transmises à l'
              <strong>enseigne partenaire du point de vente concerné</strong>{' '}
              (par exemple Carrefour, Intermarché, Supermarchés Match) aux
              seules fins de validation et de traçabilité de la transaction
              effectuée dans leur établissement. Ces données ne sont transmises
              qu'en lien direct avec une transaction que vous avez initiée et ne
              sont pas utilisées à des fins de prospection commerciale par
              lesdites enseignes sans votre consentement distinct.
            </p>

            <h3
              style={{
                color: '#2E7D32',
                fontSize: '1.3em',
                marginTop: '20px',
                marginBottom: '15px',
              }}
            >
              4.2 APPLICATIONS TIERCES
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nos Services peuvent vous donner accès à des applications tierces
              auxquelles ils sont reliés.
            </p>

            <h3
              style={{
                color: '#2E7D32',
                fontSize: '1.3em',
                marginTop: '20px',
                marginBottom: '15px',
              }}
            >
              4.3 PRESTATAIRES DE SERVICE
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nous partageons des informations avec nos prestataires de
              services, tels que banques ou établissements de crédit,
              fournisseurs d'accès internet, conseils, prestataires
              informatiques, marketing.
            </p>
          </section>

          {/* Section 5 - Finalités */}
          <section id="finalites" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              5. QUELLES SONT LES FINALITÉS DU TRAITEMENT ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Nous collectons ou traitons vos données personnelles dans le
              respect du RGPD pour les finalités suivantes :
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>
                répondre à l'<strong>intérêt légitime</strong> de notre société,
                notamment pour la lutte contre la fraude, la sécurisation des
                transactions, l'amélioration de nos services et la gestion de
                notre relation commerciale avec les enseignes partenaires
                (article 6.1.f du RGPD) ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                réaliser une vente avec vous ou répondre à votre demande ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                nous conformer à toute obligation légale ;
              </li>
              <li style={{ marginBottom: '10px' }}>prévenir la fraude ;</li>
              <li style={{ marginBottom: '10px' }}>
                <strong>
                  vérifier la présence physique de l'utilisateur dans le magasin
                  partenaire
                </strong>{' '}
                sélectionné, en temps réel et en arrière-plan pendant la session
                d'achat, afin de garantir l'intégrité des transactions Scan
                &amp; Go — sur la base de l'exécution du contrat (article 6.1.b)
                et de l'intérêt légitime (article 6.1.f du RGPD).
              </li>
            </ul>
          </section>

          {/* Section 6 - Conservation */}
          <section id="conservation" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              6. COMBIEN DE TEMPS CONSERVONS-NOUS VOS DONNÉES ?
            </h2>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>3 ans</strong> à compter du dernier contact pour un
                prospect
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>18 mois</strong> pour les statistiques de mesure
                d'audience
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>10 ans</strong> en archivage intermédiaire après la
                dernière activité
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Pendant toute la durée</strong> de la procédure, en cas
                de contentieux
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>
                  Non conservée au-delà de la session d'achat active
                </strong>{' '}
                pour les données de localisation géographique — suppression
                automatique à l'issue du paiement ou à la fermeture de
                l'application
              </li>
            </ul>
          </section>

          {/* Section 7 - Transferts hors UE */}
          <section id="transferts" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              7. TRANSFERTS DE DONNÉES HORS DE L'UNION EUROPÉENNE
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Dans le cadre de l'utilisation de prestataires techniques
              nécessaires au fonctionnement de nos services (notamment
              hébergement, authentification, paiement, et outils d'analyse),
              certaines de vos données personnelles peuvent être transférées
              vers des pays situés en dehors de l'Union européenne.
            </p>
            <p style={{ marginBottom: '15px' }}>
              Ces transferts sont effectués dans le strict respect des
              dispositions des articles 44 à 49 du RGPD, et uniquement vers des
              pays ou entités bénéficiant :
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                d'une <strong>décision d'adéquation</strong> de la Commission
                européenne ; ou
              </li>
              <li style={{ marginBottom: '10px' }}>
                de <strong>garanties appropriées</strong>, notamment via la
                signature de <strong>clauses contractuelles types</strong>{' '}
                adoptées par la Commission européenne (article 46.2.c du RGPD).
              </li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              Vous pouvez obtenir une copie des garanties mises en place en nous
              contactant à l'adresse indiquée à la section Contact.
            </p>
          </section>

          {/* Section 8 - Décision automatisée */}
          <section id="decisions" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              8. PRISE DE DÉCISION AUTOMATISÉE ET PROFILAGE
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Nous ne procédons à aucune prise de décision{' '}
              <strong>exclusivement automatisée</strong>, y compris le
              profilage, qui produirait des effets juridiques vous concernant ou
              vous affecterait de manière significative de façon similaire, au
              sens de l'article 22 du RGPD.
            </p>
            <p style={{ marginBottom: '15px' }}>
              La vérification automatisée de votre présence en magasin via la
              localisation en arrière-plan ne constitue pas une décision
              automatisée au sens dudit article : elle vise uniquement à
              sécuriser la transaction en cours et ne produit aucun effet
              juridique durable sur votre situation personnelle. En cas
              d'incohérence détectée, la session peut être suspendue à titre
              conservatoire, sans préjudice de votre droit de contacter notre
              support.
            </p>
          </section>

          {/* Section 9 - Droits */}
          <section id="droits" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              9. VOS DROITS SUR VOS DONNÉES PERSONNELLES
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Vous avez des droits garantis par les lois sur la protection de la
              vie privée et des données en Europe (RGPD, Chapitre III). Vous
              pouvez exercer gratuitement :
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>
                le droit à l'information et le droit d'accès ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                le droit de rectification ou d'effacement (droit à l'oubli) ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                le droit à la limitation du traitement ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                le droit d'opposition au traitement ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                le droit d'introduire une réclamation auprès de la CNIL ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                le droit à la portabilité de vos données.
              </li>
            </ul>
            <div
              style={{
                background: '#f8f9fa',
                padding: '25px',
                borderRadius: '12px',
                margin: '20px 0',
                borderLeft: '4px solid #4CAF50',
              }}
            >
              <p style={{ fontWeight: 'bold', marginBottom: '15px' }}>
                Pour exercer vos droits, vous pouvez nous contacter :
              </p>
              <p style={{ marginBottom: '8px' }}>
                • Par email : contact@pikkopay.fr
              </p>
              <p>
                • Par courrier : PIKKOPAY, 2 rue Gustave Eiffel, 10430
                Rosières-près-Troyes
              </p>
            </div>
          </section>

          {/* Section 10 - Contact */}
          <section id="contact" style={{ marginBottom: '40px' }}>
            <h2
              style={{
                color: '#4CAF50',
                fontSize: '1.8em',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #4CAF50',
              }}
            >
              10. CONTACT
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Si vous avez des commentaires ou des questions concernant la
              présente politique de confidentialité, veuillez nous contacter par
              courrier électronique à l'adresse suivante :
              <a
                href="mailto:contact@pikkopay.fr"
                style={{ color: '#4CAF50', marginLeft: '5px' }}
              >
                contact@pikkopay.fr
              </a>
            </p>
            <p>
              Vous pouvez également déposer une plainte auprès de la Commission
              Nationale de l'Informatique et des Libertés (CNIL), régulateur des
              données personnelles en France.
            </p>
          </section>
        </div>

        {/* Footer */}
        <footer
          style={{
            background: '#2c3e50',
            color: 'white',
            padding: '30px',
            textAlign: 'center',
            borderRadius: '0 0 20px 20px',
          }}
        >
          <p style={{ marginBottom: '10px', color: 'white' }}>
            © 2026 PIKKOPAY - Tous droits réservés
          </p>
          <p style={{ marginBottom: '10px', color: 'white' }}>
            Pour toute question :
            <a
              href="mailto:contact@pikkopay.fr"
              style={{ color: '#4CAF50', marginLeft: '5px' }}
            >
              contact@pikkopay.fr
            </a>
          </p>
          <p style={{ color: 'white' }}>
            2 rue Gustave Eiffel, 10430 Rosières-près-Troyes
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
